import React, { useEffect } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Dropdown from "../../components/Form/Dropdown";
import CustomInput from "../../components/Form/Input";
import contactUsImg from "../../assets/images/image1.webp";
import contactUsImg_LQ from "../../assets/images/image1_lq.webp";
import Button from "../../components/Form/CustomButton";
// import { ReactComponent as PhoneCallIcon } from "../../assets/icons/phone-call.svg";
import { ReactComponent as PhoneCallIcon } from "../../assets/icons/whatsapp.svg";
import { ReactComponent as EmailMultipleIcon } from "../../assets/icons/email-multiple.svg";
import { useThunk } from "../../hooks/useThunk";
import { useSelector } from "react-redux";
import useForm from "../../hooks/useForm";
import { COMMON_FIELD_TYPES } from "../../constants/fieldTypes";
import { contactUs } from "../../store";
import showToast from "../../utils/toastNotifications";
import { rolesForDropdown } from "../../constants/commonConstants";
import 'react-lazy-load-image-component/src/effects/blur.css';

const ContactUs = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  //thunk for contact us
  const [doContactUs, isContactUs, contactUsError] = useThunk(contactUs);

  const initialValues = {
    firstName: user?.firstName ?? "",
    lastName: user?.lastName ?? "",
    email: user?.email ?? "",
    subject: "",
    message: "",
    serviceProviderOrClient: "",
  };

  const requiredFields = {
    firstName: true,
    lastName: true,
    email: true,
    subject: true,
    message: true,
    serviceProviderOrClient: false,
  };

  const inputTypes = {
    firstName: COMMON_FIELD_TYPES.REQUIRED_FIELD,
    lastName: COMMON_FIELD_TYPES.REQUIRED_FIELD,
    email: COMMON_FIELD_TYPES.EMAIL_FIELD,
    subject: COMMON_FIELD_TYPES.REQUIRED_FIELD,
    message: COMMON_FIELD_TYPES.REQUIRED_FIELD,
    serviceProviderOrClient: {
      type: COMMON_FIELD_TYPES.DROPDOWN,
      displayKey: "label",
    },
  };

  const {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    setFormData,
    clearError,
  } = useForm(initialValues, requiredFields, inputTypes);

  // Handle form submission
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    setTouched({
      firstName: true,
      lastName: true,
      email: true,
      subject: true,
      message: true,
      serviceProviderOrClient: true,
    });

    if (!validateForm()) {
      console.log("Form Validation Error:", errors);
      return;
    } else {
      const result = await doContactUs(formData);
      if (result?.success) {
        showToast("success", "Inquiry submitted successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          subject: "",
          message: "",
          serviceProviderOrClient: "",
        });
      } else {
        showToast("error", result?.error?.message);
      }
    }
  };

  console.log("formData", formData);

  return (
    <div className="w-full space-x-[2px] min-w-[320px] px-[20px] md:px-[40px] lg:px-[100px] mt-12 mb-10">
      <div className="flex relative flex-col lg:flex-row gap-8 lg:gap-12 bg-white rounded-2xl px-4 py-4 pb-0 sm:p-6 lg:p-10 border border-[#CBD5E0]">
        {/* Left Section */}
        <div className="lg:w-1/2 space-y-6 flex flex-col">
          <div>
            <h1 className="text-2xl  sm:text-3xl lg:text-level-1 lg:leading-[56px] text-primary font-bold font-nonito_sans tracking-tight">
              Contact Us
            </h1>
            <p className="mt-3 max-w-lg  font-inter text-level-6 leading-[22px] text-content">
              Have questions or need assistance? We're here to help! Please feel
              free to reach out to our support team for any inquiries, feedback,
              or technical assistance.
            </p>
          </div>

          <div className="space-y-4 font-inter font-medium text-content text-level-6">
            <div className="flex items-center">
              <span className="w-12 h-12 rounded-full bg-[#EAEAEA] flex items-center justify-center shrink-0">
                <PhoneCallIcon className="w-6 h-6 fill-current text-primary-text" />
              </span>
              <a
                href="tel:+233271752953"
                className="ml-4 hover:text-blue-500 cursor-pointer transition-all duration-150 ease-in-out"
              >
                +233271752953
              </a>
            </div>

            <div className="flex items-center">
              <span className="w-12 h-12 rounded-full bg-[#EAEAEA] flex items-center justify-center shrink-0">
                <EmailMultipleIcon className="w-6 h-6 fill-current text-primary-text" />
              </span>
              <a
                href="mailto:support@jumaconnect.com"
                className="ml-4 hover:text-blue-500 cursor-pointer transition-all duration-150 ease-in-out"
              >
                support@jumaconnect.com
              </a>
            </div>
          </div>

          <div className="hidden lg:block bottom-0 absolute">
            <LazyLoadImage
              src={contactUsImg}
              placeholderSrc={contactUsImg_LQ}
              alt="Contact Us"
              className="max-w-full h-auto object-contain"
              effect="blur"
            />
          </div>
        </div>

        {/* Form Section */}
        <div className="lg:w-1/2">
          <div className=" bg-light border-b-2 rounded-xl p-0 sm:p-6 lg:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3">
              <CustomInput
                type="text"
                name="firstName"
                placeholder="First Name"
                className="w-full h-14 px-4 rounded-lg border border-gray-300 text-content"
                value={formData.firstName}
                error={touched.firstName && errors.firstName}
                onChange={(e) => handleInputChange("firstName", e.target.value)}
                onBlur={() => handleBlur("firstName", formData.firstName)}
                onFocus={() => clearError("firstName")}
                disabled={isAuthenticated}
              />
              <CustomInput
                type="text"
                name="lastName"
                placeholder="Last Name"
                className="w-full h-14 px-4 rounded-lg border border-gray-300 text-content"
                value={formData.lastName}
                error={touched.lastName && errors.lastName}
                onChange={(e) => handleInputChange("lastName", e.target.value)}
                onBlur={() => handleBlur("lastName", formData.lastName)}
                onFocus={() => clearError("lastName")}
                disabled={isAuthenticated}
              />
            </div>
            <div className=" flex flex-col space-y-2">
              <Dropdown //error is occured when clicking submit empty value is passed when submit and validation error occur.
                placeholder="Inquiry as Service Provider Or Client"
                idKey="id"
                displayKey="label"
                options={rolesForDropdown}
                defaultOption={formData.serviceProviderOrClient || ""}
                onSelect={(selectedOption) => {
                  handleInputChange("serviceProviderOrClient", selectedOption); // Store full object
                }}
                onBlur={() =>
                  handleBlur(
                    "serviceProviderOrClient",
                    formData.serviceProviderOrClient
                  )
                }
                buttonClassName="h-14 px-4 rounded-lg border font-inter text-content"
                optionClassName="font-inter text-content text-level-6"
              />

              <CustomInput
                type="email"
                name="email"
                placeholder="Email"
                className="w-full h-14 mt-3 px-4 rounded-lg border border-gray-300 text-content"
                value={formData.email}
                error={touched.email && errors.email}
                onChange={(e) => handleInputChange("email", e.target.value)}
                onBlur={() => handleBlur("email", formData.email)}
                onFocus={() => clearError("email")}
                disabled={isAuthenticated}
              />

              <CustomInput
                type="text"
                name="subject"
                placeholder="Subject"
                className="w-full h-14 px-4 rounded-lg border border-gray-300 text-content"
                value={formData.subject}
                error={touched.subject && errors.subject}
                onChange={(e) => handleInputChange("subject", e.target.value)}
                onBlur={() => handleBlur("subject", formData.subject)}
              />

              <CustomInput
                type="textarea"
                name="message"
                placeholder="Message"
                className="w-full h-32 mb-[44px] lg:mb-[88px] lg:h-40 px-4 py-3 rounded-lg border border-gray-300 text-content resize-none"
                value={formData.message}
                error={touched.message && errors.message}
                onChange={(e) => handleInputChange("message", e.target.value)}
                onBlur={() => handleBlur("message", formData.message)}
                onFocus={() => clearError("message")}
              />
            </div>

            <Button
              buttonText="Submit"
              bgColor="bg-primary"
              textColor="text-tertiary"
              width="w-full"
              height="h-12"
              borderColor="border-transparent"
              loading={isContactUs}
              loaderColor="white"
              type="submit"
              onClick={handleFormSubmit}
            />
          </div>
        </div>

        {/* Mobile Image */}
        <div className="lg:hidden mt-6">
          <LazyLoadImage
            src={contactUsImg}
            placeholderSrc={contactUsImg_LQ}
            alt="Contact Us"
            className="max-w-full h-auto mx-auto object-contain"
            effect="blur"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
